import { createAction } from 'redux-actions';

const actionKey = 'WATCH_SUGGESTIONS';

export interface UnsuggestUserPayload {
  userid: number;
}
export const unsuggestUser = createAction(
  `${actionKey}.UNSUGGEST.USER`,
  (payload: UnsuggestUserPayload) => payload
);
